import React from "react";

export const IconDownArrow = (): React.JSX.Element => {
    return (
        <svg width="18" height="18" viewBox="0 0 20 20" className="svg-icon caret-icon animation-rotate-180 ">
            <path
                d="M15.191 7.28a1.108 1.108 0 0 0-1.471 0l-3.746 3.4-3.694-3.4a1.108 1.108 0 0 0-1.471 0 .924.924 0 0 0-.309.681c0 .256.111.502.309.682l4.424 4.073c.196.182.463.284.74.284.28 0 .546-.102.742-.284l4.476-4.073a.924.924 0 0 0 .309-.682.924.924 0 0 0-.309-.682z"
                fill="#8A8F98"/>
        </svg>
    )

}

export const ErrorIcon = (): React.JSX.Element => {
    return (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="15" cy="15" r="14.5" fill="#960014" fillOpacity="0.5" stroke="#850101"/>
            <path
                d="M16.2676 7.78125L15.9453 17.6543H13.6016L13.2695 7.78125H16.2676ZM13.1914 20.7109C13.1914 20.2943 13.3346 19.9492 13.6211 19.6758C13.9141 19.3958 14.2982 19.2559 14.7734 19.2559C15.2552 19.2559 15.6393 19.3958 15.9258 19.6758C16.2122 19.9492 16.3555 20.2943 16.3555 20.7109C16.3555 21.1146 16.2122 21.4564 15.9258 21.7363C15.6393 22.0163 15.2552 22.1562 14.7734 22.1562C14.2982 22.1562 13.9141 22.0163 13.6211 21.7363C13.3346 21.4564 13.1914 21.1146 13.1914 20.7109Z"
                fill="#960014"/>
        </svg>

    )
}

export const InfoIcon = (): React.JSX.Element => {
    return (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="15" cy="15" r="14.5" fill="#001060" fillOpacity="0.45" stroke="#001060"/>
            <path
                d="M16.2676 7.78125L15.9453 17.6543H13.6016L13.2695 7.78125H16.2676ZM13.1914 20.7109C13.1914 20.2943 13.3346 19.9492 13.6211 19.6758C13.9141 19.3958 14.2982 19.2559 14.7734 19.2559C15.2552 19.2559 15.6393 19.3958 15.9258 19.6758C16.2122 19.9492 16.3555 20.2943 16.3555 20.7109C16.3555 21.1146 16.2122 21.4564 15.9258 21.7363C15.6393 22.0163 15.2552 22.1562 14.7734 22.1562C14.2982 22.1562 13.9141 22.0163 13.6211 21.7363C13.3346 21.4564 13.1914 21.1146 13.1914 20.7109Z"
                fill="#001060"/>
        </svg>
    )
}